module.exports = __webpack_public_path__ + "img/infohub-blue-logo.682318e0.svg";